// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"2041438a","796":"c8d68ec6"}[chunkId] + ".chunk.js";
};